// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-top-right {
  position: absolute;
  top: 5px;
  right: 5px;
}

.btn-favourite:hover .btn-top-right {
  display: block;
}

.card-body {
  word-wrap: break-word;
  white-space: pre-wrap;
  cursor: pointer;
}

.card {
  min-height: 100px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/preferiti/preferiti.component.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AACJ;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,qBAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;AACF","sourcesContent":[".btn-top-right {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n}\n\n.btn-favourite:hover .btn-top-right {\n  display: block;\n}\n\n.card-body {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  cursor: pointer;\n}\n\n.card {\n  min-height: 100px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
